import {createSelector} from 'reselect';

import {AppState} from '../../configStore';

const selectSystemAnnouncementBase = (state: AppState) => state.systemAnnouncement;

export const selectSystemAnnouncement = createSelector(
  selectSystemAnnouncementBase,
  ({data}) => data,
);

export const selectSystemAnnouncementLoading = createSelector(
  selectSystemAnnouncementBase,
  systemAnnouncement => systemAnnouncement.loading,
);

export const selectSystemAnnouncementLoaded = createSelector(
  selectSystemAnnouncementBase,
  systemAnnouncement => systemAnnouncement.loaded,
);

export const selectSystemAnnouncementFetchedFor = createSelector(
  selectSystemAnnouncement,
  data => data?.fetchedFor || '',
);
